<template>
  <div>
    <el-row style="margin-bottom: 20px">
      <el-input v-model="queryInfo.materialCode" class="input" placeholder="备件编码" clearable></el-input>
      <el-button type="primary" @click="currentChange(1)" :loading="loading">查询</el-button>
      <el-button type="primary" @click="importDialogVisible = true" :loading="loading">全量导入</el-button>
    </el-row>

    <el-table :data="dataList" border style="width: 100%" stripe>
      <el-table-column align="center" prop="materialCode" label="备件编码"></el-table-column>
      <el-table-column align="center" prop="coaCode" label="COA编码"></el-table-column>
      <el-table-column align="center" prop="createUserName" label="创建人"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination background layout="total,prev, pager, next" :page-size="pageSize" :total="total" @current-change="currentChange" :current-page.sync="queryInfo.pageNo"></el-pagination>
    </div>

    <el-dialog title="全量导入COA编码" :visible.sync="importDialogVisible" :close-on-click-modal="false" width="800px" :before-close="importHandleClose">
      <ImportComponent template-url="template/boardGsku.xlsx" upload-url="boardGsku/upload"/>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importHandleClose">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import ImportComponent from "@/components/ImportComponent.vue";

export default {
  name: "BoardGsku",
  components: {ImportComponent},
  data() {
    return {
      queryInfo: {
        materialCode: '',
        pageNo: 1
      },
      dataList: [],
      total: 0,
      pageSize: 0,
      loading: false,
      importDialogVisible: false
    }
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.$axios.post('boardGsku/queryList', this.queryInfo).then(response => {
        this.loading = false;
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.dataList = res.data.records;
        this.total = res.data.total;
        this.pageSize = res.data.size;
      }, error => {
        this.loading = false;
        return this.$message.error('查询失败，' + error.message);
      });

    },
    currentChange(pageNo) {
      this.queryInfo.pageNo = pageNo;
      this.search()
    },
    importHandleClose() {
      this.currentChange(1);
      this.importDialogVisible = false;
    },
  }
}
</script>

<style scoped>
.input {
  width: 300px;
  margin-right: 10px;
}
</style>